// extracted by mini-css-extract-plugin
export default {"introductionContentWrapper":"introductionContentWrapper__7C6I8fs7","sectionWrapper":"sectionWrapper__RBa6u5Ku"};